import { Component, Input } from '@angular/core';
import { TestSystemModel } from '@medindex-webapi';

@Component({
  selector: 'app-test-systems',
  templateUrl: './test-systems.component.html',
})
export class TestSystemsComponent {
  @Input() items: TestSystemModel[] = [];
}
